<template>
    <div class="loading">
		<span @click="pageBack()">< 返回上一个页面</span>
		<div>
            <img src="../../assets/img/public/loading.gif" alt="">
        </div>
        <p>Loading...</p>
    </div>
</template>

<script>
    export default {
        name: "loading"
    }
</script>

<style scoped>
    .loading{
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 1);
        top: 0;
        left: 0;
        text-align: center;
        z-index: 999;
    }
	.loading span{
		display: block;
		width: 7rem;
		margin: 0 auto;
		line-height: 1rem;
		font-size: 0.23rem;
		color: #6990ff;
		text-align: left;
	}
    .loading p{
        width: 100%;
        position: absolute;
        text-align: center;
        top: calc((100% + 1.2rem) / 2);
        left: 0;
    }
    .loading div{
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        top: calc((100% - 0.8rem) / 2);
        left: calc((100% - 0.8rem) / 2);
    }
    .loading div img{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/module/loading/loading.vue